export default function Button({
    as = 'button',
    variant = 'primary',
    size = 'md',
    className = '',
    ...props
  }) {
    const Comp = as;
    const base = 'inline-flex items-center justify-center rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
    const sizes = {
      sm: 'text-sm px-3 py-1.5',
      md: 'text-sm px-4 py-2',
      lg: 'text-base px-5 py-2.5',
    };
    const variants = {
      primary: 'bg-brand-600 text-white hover:bg-brand-700 focus:ring-brand-600',
      secondary: 'bg-white text-gray-900 border border-gray-300 hover:bg-gray-50',
      ghost: 'text-gray-700 hover:bg-gray-100',
      danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-600',
    };
    return (
      <Comp className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} {...props} />
    );
  }
  